<icds-tag [dataDisplay]="data().label | translate" [dataVariant]="data().variant" />
